module.exports = __webpack_public_path__ + "img/educationalTraining2.b328226a.png";